import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ITicker, ITrendingItem } from '@kattana-io/common';
import Image from '../../atoms/Image';
import { IStore } from '../../reducers';
import TrendingCoin, { GainersPair } from '../Trending/TrendingCoin';
import useTicker from '../../hooks/useTicker';

import flash from '../../assets/images/flash.svg';

import './styles.scss';

const MAX_GAINERS_COUNT = 10;

/**
 * Combine gainers into trending format
 * @param state
 * @returns
 */
export const useMarqueeItems = () => {
  const { loading, trending, gainers } = useSelector(
    (state: IStore) => state.registry
  );
  const [items, setItems] = useState<ITrendingItem[]>([]);

  useEffect(() => {
    if (gainers && gainers.pairs) {
      const { yesterday_prices, pairs } = gainers;
      const marqueeItems = pairs.slice(0, MAX_GAINERS_COUNT);
      setItems(
        marqueeItems.map((ticker: ITicker) => {
          const { name, price_usd } = useTicker(ticker);
          const yPrice = yesterday_prices[ticker.id];
          const yesterdayPriceUSD = ticker.flipped
            ? yPrice.price_b_usd
            : yPrice.price_a_usd;

          const priceDiff = price_usd - yesterdayPriceUSD;
          const priceDiffPer = parseFloat(
            ((priceDiff / yesterdayPriceUSD) * 100).toFixed(2)
          );

          return {
            id: ticker.id,
            label: name,
            ticker_id: ticker.id,
            ticker: ticker,
            link: '',
            order: 0,
            price: priceDiffPer, // set price change
          };
        })
      );
    }
  }, [gainers]);

  return {
    loading,
    trending,
    items,
  };
};

/**
 * Renders marquee - a top floating tickers bar
 */
const TickersDisplayBar = () => {
  const { items, trending, loading } = useMarqueeItems();
  const [running, setRunning] = useState<boolean>(true);
  const runAttribute = running ? '' : 'marquee__group--stopped';

  return (
    <div className='tickers_display_bar'>
      {loading && <span>...</span>}
      <div className='trending__icon' onClick={() => setRunning(!running)}>
        <Image src={flash} size='m' />
      </div>
      <div className='marquee'>
        <div className={`marquee__group ${runAttribute}`}>
          {trending.map((item: ITrendingItem) => (
            <TrendingCoin key={item.id} item={item} />
          ))}
          {items.map((item: ITrendingItem) => (
            <GainersPair key={item.id} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TickersDisplayBar;
